import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export function ContactAgentMetricCard({
  title,
  value,
  hint,
  valueClassName = 'text-2xl',
}: {
  title: string;
  value: string;
  hint?: string;
  valueClassName?: string;
}) {
  return (
    <Card className='rounded-2xl shadow-sm'>
      <CardHeader className='pb-2'>
        <CardTitle className='text-sm font-medium text-muted-foreground'>{title}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className={`${valueClassName} font-semibold tracking-tight`}>{value}</div>
        {hint ? <p className='mt-1 text-xs text-muted-foreground'>{hint}</p> : null}
      </CardContent>
    </Card>
  );
}
